import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><div parentName="p" {...{
        "className": "mermaid"
      }}><svg parentName="div" {...{
          "aria-role-description": ["flowchart-v2"],
          "role": "graphics-document document",
          "viewBox": "-7.5 -8 759.859375 177.75",
          "style": {
            "maxWidth": "759.859375px"
          },
          "xmlns": "http://www.w3.org/2000/svg",
          "width": "100%",
          "id": "mermaid-0"
        }}><style parentName="svg">{`#mermaid-0{font-family:arial,sans-serif;font-size:16px;fill:#333;}#mermaid-0 .error-icon{fill:#552222;}#mermaid-0 .error-text{fill:#552222;stroke:#552222;}#mermaid-0 .edge-thickness-normal{stroke-width:2px;}#mermaid-0 .edge-thickness-thick{stroke-width:3.5px;}#mermaid-0 .edge-pattern-solid{stroke-dasharray:0;}#mermaid-0 .edge-pattern-dashed{stroke-dasharray:3;}#mermaid-0 .edge-pattern-dotted{stroke-dasharray:2;}#mermaid-0 .marker{fill:#333333;stroke:#333333;}#mermaid-0 .marker.cross{stroke:#333333;}#mermaid-0 svg{font-family:arial,sans-serif;font-size:16px;}#mermaid-0 .label{font-family:arial,sans-serif;color:#333;}#mermaid-0 .cluster-label text{fill:#333;}#mermaid-0 .cluster-label span,#mermaid-0 p{color:#333;}#mermaid-0 .label text,#mermaid-0 span,#mermaid-0 p{fill:#333;color:#333;}#mermaid-0 .node rect,#mermaid-0 .node circle,#mermaid-0 .node ellipse,#mermaid-0 .node polygon,#mermaid-0 .node path{fill:#ECECFF;stroke:#9370DB;stroke-width:1px;}#mermaid-0 .flowchart-label text{text-anchor:middle;}#mermaid-0 .node .label{text-align:center;}#mermaid-0 .node.clickable{cursor:pointer;}#mermaid-0 .arrowheadPath{fill:#333333;}#mermaid-0 .edgePath .path{stroke:#333333;stroke-width:2.0px;}#mermaid-0 .flowchart-link{stroke:#333333;fill:none;}#mermaid-0 .edgeLabel{background-color:#e8e8e8;text-align:center;}#mermaid-0 .edgeLabel rect{opacity:0.5;background-color:#e8e8e8;fill:#e8e8e8;}#mermaid-0 .labelBkg{background-color:rgba(232, 232, 232, 0.5);}#mermaid-0 .cluster rect{fill:#ffffde;stroke:#aaaa33;stroke-width:1px;}#mermaid-0 .cluster text{fill:#333;}#mermaid-0 .cluster span,#mermaid-0 p{color:#333;}#mermaid-0 div.mermaidTooltip{position:absolute;text-align:center;max-width:200px;padding:2px;font-family:arial,sans-serif;font-size:12px;background:hsl(80, 100%, 96.2745098039%);border:1px solid #aaaa33;border-radius:2px;pointer-events:none;z-index:100;}#mermaid-0 .flowchartTitleText{text-anchor:middle;font-size:18px;fill:#333;}#mermaid-0 :root{--mermaid-font-family:arial,sans-serif;}`}</style><g parentName="svg"><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "12",
              "markerWidth": "12",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "6",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-0_flowchart-pointEnd"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 0 0 L 10 5 L 0 10 z"
              }}></path></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "12",
              "markerWidth": "12",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "4.5",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-0_flowchart-pointStart"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 0 5 L 10 10 L 10 0 z"
              }}></path></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "11",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-0_flowchart-circleEnd"
            }}><circle parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "r": "5",
                "cy": "5",
                "cx": "5"
              }}></circle></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "-1",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-0_flowchart-circleStart"
            }}><circle parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "r": "5",
                "cy": "5",
                "cx": "5"
              }}></circle></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5.2",
              "refX": "12",
              "viewBox": "0 0 11 11",
              "className": "marker cross flowchart",
              "id": "mermaid-0_flowchart-crossEnd"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "2",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 1,1 l 9,9 M 10,1 l -9,9"
              }}></path></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5.2",
              "refX": "-1",
              "viewBox": "0 0 11 11",
              "className": "marker cross flowchart",
              "id": "mermaid-0_flowchart-crossStart"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "2",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 1,1 l 9,9 M 10,1 l -9,9"
              }}></path></marker><g parentName="g" {...{
              "className": "root"
            }}><g parentName="g" {...{
                "className": "clusters"
              }}></g><g parentName="g" {...{
                "className": "edgePaths"
              }}></g><g parentName="g" {...{
                "className": "edgeLabels"
              }}></g><g parentName="g" {...{
                "className": "nodes"
              }}><g parentName="g" {...{
                  "transform": "translate(-7.5, -8)",
                  "className": "root"
                }}><g parentName="g" {...{
                    "className": "clusters"
                  }}><g parentName="g" {...{
                      "id": "Approved",
                      "className": "cluster default flowchart-label"
                    }}><rect parentName="g" {...{
                        "height": "161.75",
                        "width": "743.859375",
                        "y": "8",
                        "x": "8",
                        "ry": "0",
                        "rx": "0",
                        "style": {}
                      }}></rect><g parentName="g" {...{
                        "transform": "translate(280.0390625, 8)",
                        "className": "cluster-label"
                      }}><foreignObject parentName="g" {...{
                          "height": "19",
                          "width": "199.78125"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "nodeLabel"
                            }}>{`Proposal implementation`}</span></div></foreignObject></g></g></g><g parentName="g" {...{
                    "className": "edgePaths"
                  }}><path parentName="g" {...{
                      "markerEnd": "url(#mermaid-0_flowchart-pointEnd)",
                      "style": {
                        "fill": "none"
                      },
                      "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-ApprovedStatus LE-Fetch",
                      "id": "L-ApprovedStatus-Fetch-0",
                      "d": "M124.75,88.875L128.917,88.875C133.083,88.875,141.417,88.875,148.867,88.875C156.317,88.875,162.883,88.875,166.167,88.875L169.45,88.875"
                    }}></path><path parentName="g" {...{
                      "markerEnd": "url(#mermaid-0_flowchart-pointEnd)",
                      "style": {
                        "fill": "none"
                      },
                      "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Fetch LE-Push",
                      "id": "L-Fetch-Push-0",
                      "d": "M342.109,88.875L346.276,88.875C350.443,88.875,358.776,88.875,366.226,88.875C373.676,88.875,380.243,88.875,383.526,88.875L386.809,88.875"
                    }}></path><path parentName="g" {...{
                      "markerEnd": "url(#mermaid-0_flowchart-pointEnd)",
                      "style": {
                        "fill": "none"
                      },
                      "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Push LE-Check",
                      "id": "L-Push-Check-0",
                      "d": "M523.078,88.875L527.245,88.875C531.411,88.875,539.745,88.875,547.278,88.941C554.812,89.007,561.545,89.139,564.912,89.205L568.279,89.271"
                    }}></path></g><g parentName="g" {...{
                    "className": "edgeLabels"
                  }}><g parentName="g" {...{
                      "className": "edgeLabel"
                    }}><g parentName="g" {...{
                        "transform": "translate(0, 0)",
                        "className": "label"
                      }}><foreignObject parentName="g" {...{
                          "height": "0",
                          "width": "0"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "edgeLabel"
                            }}></span></div></foreignObject></g></g><g parentName="g" {...{
                      "className": "edgeLabel"
                    }}><g parentName="g" {...{
                        "transform": "translate(0, 0)",
                        "className": "label"
                      }}><foreignObject parentName="g" {...{
                          "height": "0",
                          "width": "0"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "edgeLabel"
                            }}></span></div></foreignObject></g></g><g parentName="g" {...{
                      "className": "edgeLabel"
                    }}><g parentName="g" {...{
                        "transform": "translate(0, 0)",
                        "className": "label"
                      }}><foreignObject parentName="g" {...{
                          "height": "0",
                          "width": "0"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "edgeLabel"
                            }}></span></div></foreignObject></g></g></g><g parentName="g" {...{
                    "className": "nodes"
                  }}><g parentName="g" {...{
                      "transform": "translate(78.875, 88.875)",
                      "id": "flowchart-ApprovedStatus-0",
                      "className": "node default secondary CircleSize50 flowchart-label"
                    }}><circle parentName="g" {...{
                        "height": "53",
                        "width": "91.75",
                        "r": "45.875",
                        "ry": "0",
                        "rx": "0",
                        "style": {}
                      }}></circle><g parentName="g" {...{
                        "transform": "translate(-38.375, -19)",
                        "style": {},
                        "className": "label"
                      }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                          "height": "38",
                          "width": "76.75"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "nodeLabel"
                            }}>{`Approved `}<br parentName="span"></br>{` status`}</span></div></foreignObject></g></g><g parentName="g" {...{
                      "transform": "translate(258.4296875, 88.875)",
                      "id": "flowchart-Fetch-1",
                      "className": "node default default flowchart-label"
                    }}><rect parentName="g" {...{
                        "height": "53",
                        "width": "167.359375",
                        "y": "-26.5",
                        "x": "-83.6796875",
                        "ry": "0",
                        "rx": "0",
                        "style": {},
                        "className": "basic label-container"
                      }}></rect><g parentName="g" {...{
                        "transform": "translate(-76.1796875, -19)",
                        "style": {},
                        "className": "label"
                      }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                          "height": "38",
                          "width": "152.359375"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "nodeLabel"
                            }}>{`Fetch proposal and `}<br parentName="span"></br>{` implement locally`}</span></div></foreignObject></g></g><g parentName="g" {...{
                      "transform": "translate(457.59375, 88.875)",
                      "id": "flowchart-Push-2",
                      "className": "node default default flowchart-label"
                    }}><rect parentName="g" {...{
                        "height": "53",
                        "width": "130.96875",
                        "y": "-26.5",
                        "x": "-65.484375",
                        "ry": "0",
                        "rx": "0",
                        "style": {},
                        "className": "basic label-container"
                      }}></rect><g parentName="g" {...{
                        "transform": "translate(-57.984375, -19)",
                        "style": {},
                        "className": "label"
                      }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                          "height": "38",
                          "width": "115.96875"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "nodeLabel"
                            }}>{`Run checks on `}<br parentName="span"></br>{` local changes`}</span></div></foreignObject></g></g><g parentName="g" {...{
                      "transform": "translate(649.96875, 88.875)",
                      "id": "flowchart-Check-3",
                      "className": "node default tertiary flowchart-label"
                    }}><polygon parentName="g" {...{
                        "style": {},
                        "transform": "translate(-68.890625,26.5)",
                        "className": "label-container",
                        "points": "0,0 137.78125,0 137.78125,-53 0,-53 0,0 -8,0 145.78125,0 145.78125,-53 -8,-53 -8,0"
                      }}></polygon><g parentName="g" {...{
                        "transform": "translate(-61.390625, -19)",
                        "style": {},
                        "className": "label"
                      }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                          "height": "38",
                          "width": "122.78125"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "nodeLabel"
                            }}>{`GraphOS `}<br parentName="span"></br>{` schema checks`}</span></div></foreignObject></g></g></g></g></g></g></g></svg></div></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      